import { showErrorToast } from '../../actions/notification-actions';
import { GENERIC_ERROR_TOAST_TITLE, isDuplicateListNameError } from './listErrors';

export const DUPLICATE_LIST_NAME_ERROR_MESSAGE = 'A list with this name already exists. Please choose a different name.';

// Shared save-error handling for the two "add player(s) to list" modals: only a 400 that names the
// submitted new list as a duplicate renders inline under the name field — with no name submitted
// there is no name collision to report, so an unrelated "already exists" 400 correctly falls through
// to the generic error toast instead of a name error under an empty field.
export const handleSaveToListError = ({ error, hasNewListName, dispatch, setNameError, genericMessage }) => {
    if (hasNewListName && isDuplicateListNameError(error)) {
        setNameError(DUPLICATE_LIST_NAME_ERROR_MESSAGE);
    } else {
        dispatch(showErrorToast({
            title: GENERIC_ERROR_TOAST_TITLE,
            message: genericMessage,
        }));
    }
};
